import { AlertProvider } from '@/lib/alerts/hooks/useAlert';
import { ConfirmProvider } from '@/lib/alerts/hooks/useConfirm';
import { AuthProvider } from '@/lib/auth/hooks/useAuth';
import { LoadingProvider } from '@/lib/loading/hooks/useLoading';
import { ReactNode } from 'react';
import { HeroUIProvider, ToastProvider } from '@heroui/react';
import { useNavigate } from '@tanstack/react-router';
import { DemoProvider } from '@/lib/demo/hooks/useDemo';

function Providers({ children }: { children: ReactNode }) {
    const navigate = useNavigate();
    const push = (path: string) => navigate({ to: path });
    return (
        <HeroUIProvider navigate={push}>
            <ToastProvider />
            <DemoProvider>
                <LoadingProvider>
                    <AlertProvider>
                        <ConfirmProvider>
                            <AuthProvider>{children}</AuthProvider>
                        </ConfirmProvider>
                    </AlertProvider>
                </LoadingProvider>
            </DemoProvider>
        </HeroUIProvider>
    );
}

export default Providers;
